<template>
  <header class="topbar">
    <button class="icon-button" type="button" @click="$emit('toggle')">
      <i class="el-icon-menu"></i>
    </button>
    <div class="topbar-title">{{ title }}</div>
    <div class="topbar-user">
      <el-select v-model="language" class="language-select" size="mini" @change="changeLanguage">
        <el-option label="EN" value="en"></el-option>
        <el-option label="FR" value="fr"></el-option>
      </el-select>
      <span>{{ username }}</span>
      <button class="text-button" type="button" @click="logout">{{ $t('actions.logout') }}</button>
    </div>
  </header>
</template>

<script>
import { clearAuth, getLanguage, getUsername } from '../store';

export default {
  name: 'Header',
  props: {
    collapsed: Boolean
  },
  data() {
    return {
      language: getLanguage()
    };
  },
  computed: {
    title() {
      return this.$route.meta.titleKey ? this.$t(this.$route.meta.titleKey) : this.$t('appTitle');
    },
    username() {
      return getUsername();
    }
  },
  methods: {
    changeLanguage(value) {
      this.$setLanguage(value);
    },
    logout() {
      clearAuth();
      this.$router.replace('/login');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/Header.vue